import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { NetworkPublicInfo } from '@tribeplatform/gql-client/types'

import { RuntimeConfigs } from '../../../../../../configs/runtime.js'

export const getWorkspaceDomain = (workspace: NetworkPublicInfo) => {
  return workspace.domainSubfolder ?? workspace.domain
}

// TODO: nexus-signup should expose a stable auth-gateway route so this URL doesn't break when its base path changes.
export const buildWorkspaceLoginUrl = (workspace: NetworkPublicInfo) => {
  return `${RuntimeConfigs.WORKSPACE_AUTH_GATEWAY_URL}/account/login/?network=${workspace.id}&networkPath=${encodeURIComponent(adminRoutes.root)}`
}
